export default [
  'BOTCustomSchemas'
]

/* Appears on pages specified by the condition
banner and modal window can be displayed on different pages, independently of each other */
